import { render } from "./MemberAvatar.vue?vue&type=template&id=8b39e226"
import script from "./MemberAvatar.vue?vue&type=script&lang=js"
export * from "./MemberAvatar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/workspace/okshop-diner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__